import React, { FocusEvent } from 'react';

import { adminSettingsUtils } from 'utils/selectOptionsUtils';

import { QuantityFormatSelect } from './QuantityFormatSelect';

interface IQuantityFormatSeparatorFieldProps {
  header: string;
  name: string;
  value: string;
  isFetching: boolean;
  error: boolean;
  onFieldChange: (fieldPath: string, rawValue: string) => void;
  onBlur: (event: FocusEvent<HTMLElement>) => void;
}

export const QuantityFormatSeparatorField = ({
  header,
  name,
  value,
  isFetching,
  error,
  onFieldChange,
  onBlur
}: IQuantityFormatSeparatorFieldProps): React.ReactElement => (
  <QuantityFormatSelect
    header={header}
    name={name}
    value={value}
    items={adminSettingsUtils.separatorOptions}
    isFetching={isFetching}
    error={error}
    onFieldChange={onFieldChange}
    onBlur={onBlur}
  />
);
